export class AutoPayChangeData {
  public LastFour?: string;
  public PaymentType?: string;
  public PaymentAccountType?: string;
}
